<template>
  <div class="page-content">
    <a-card :loading="false">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" v-bind="layout">
        <a-form-model-item :colon="false" has-feedback label="账号" prop="account">
          <span class="form-account">{{account}}</span>
        </a-form-model-item>
        <a-form-model-item :colon="false" has-feedback label="原密码" prop="oldPassword">
          <a-input v-model="ruleForm.oldPassword" placeholder="请输入原密码" type="password" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item :colon="false" has-feedback label="新密码" prop="newPassword">
          <a-input v-model="ruleForm.newPassword" :max-length="16" placeholder="6-16位，必须包含数字和字母" type="password" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item :colon="false" has-feedback label="新密码确认" prop="confirmedNewPassword">
          <a-input v-model="ruleForm.confirmedNewPassword" placeholder="再次填写上面的密码" type="password" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" :loading="loading.handleSave" @click="submitForm('ruleForm')">
            提交
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import loadingMixin from '@thales/loading'
import { mapState } from 'vuex'
import { logout } from '@/services/user'
import { isEmpty } from '../../utils/type'
import { validate, passwordValidator, oldPasswordValidator } from '../../utils/validate'
import { modifyPassword } from './api/auth'

export default {
  mixins: [loadingMixin],
  data() {
    // eslint-disable-next-line consistent-return
    const password2Validator = validate(value => {
      if(isEmpty(value)) {
        return '请输入密码'
      }
      if (value !== this.ruleForm.newPassword) {
        return '两次密码输入不一致'
      }
    })
    return {
      loading: {
        handleSave: false
      },
      ruleForm: {
        oldPassword: '',
        newPassword: '',
        confirmedNewPassword: ''
      },
      rules: {
        oldPassword: [{ validator: oldPasswordValidator, trigger: 'change' }],
        newPassword: [{ validator: passwordValidator, trigger: 'change' }],
        confirmedNewPassword: [{ validator: password2Validator, trigger: 'change' }]
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 8 },
      },
    };
  },
  computed: {
    ...mapState('user', ['userId', 'account'])
  },
  methods: {
    submitForm(formName) {
      // eslint-disable-next-line consistent-return
      this.$refs[formName].validate(async valid => {
        if (valid) {
          await this.handleSave()
        } else {
          return false;
        }
      });
    },
    async handleSave() {
      const form = {
        ...this.ruleForm,
        accountId: this.userId
      }
      await modifyPassword(form)
      this.$message.success('操作成功！')
      setTimeout(() => {
        this.logout()
      }, 1000)
    },
    logout() {
      logout()
      this.$router.push('/login')
    },
  },
}
</script>

<style lang="less" scoped>
.page-content {
  ::v-deep .ant-card {
    border-radius: 4px;
  }
  .form-account {
    color: #323232;
  }
}
</style>
